import React, { useEffect, useRef, useState } from "react";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import { FaFilter } from "react-icons/all";
import CustomModal from "../UI/CustomModal";
import Checkbox from "@mui/material/Checkbox";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import { useDispatch, useSelector } from "react-redux";
import { themModeSelector } from "../../redux/selectors/AuthSelectors";
import { InitialCalcPlatform } from "./helper";
import { setCalculatorPlatform } from "../../redux/actions/CalculatorAction";
import { calculatorPlatformsSelector } from "../../redux/selectors/CalculatorSelectors";
import CustomButton from "../UI/CustomButton/inedx";
import { OverlayTrigger, Popover } from "react-bootstrap";
import { CloseIconWithTooltip } from "../onboarding/tutorialLanding";
import Button from "@mui/material/Button";

const CalculatorSetting = () => {
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  const platforms = useSelector(calculatorPlatformsSelector);
  const { isDarkMode } = useSelector(themModeSelector);
  const [calculatorPlatforms, setCalculatorPlatformsVal] = useState(platforms);
  const activeCalcId = calculatorPlatforms
    ? calculatorPlatforms.map((d) => d.value)
    : [];

  const isViewFilterPopover = localStorage.getItem("isViewFilterPopover");
  const [showPopover, setShowPopover] = useState(!isViewFilterPopover);

  useEffect(() => {
    setCalculatorPlatformsVal(platforms);
  }, [platforms]);

  useEffect(() => {
    const listener = (event) => {
      setShowPopover(false);
      localStorage.setItem("isViewFilterPopover", "true");
    };
    document.addEventListener("mousedown", listener);
    document.addEventListener("touchstart", listener);
    return () => {
      document.removeEventListener("mousedown", listener);
      document.removeEventListener("touchstart", listener);
    };
  }, []);

  const handleChange = ({ target: { name, checked } }) => {
    if (checked) {
      const existArray = [...calculatorPlatforms];
      const newObj = InitialCalcPlatform.find((d) => d.value === name);
      setCalculatorPlatformsVal([...existArray, newObj]);
    } else {
      const filterData = calculatorPlatforms.filter((d) => d.value !== name);
      setCalculatorPlatformsVal([...filterData]);
    }
  };

  useEffect(() => {
    dispatch(setCalculatorPlatform(InitialCalcPlatform));
  }, []);

  const handleReset = () => {
    setCalculatorPlatformsVal(InitialCalcPlatform);
    dispatch(setCalculatorPlatform(InitialCalcPlatform));
  };

  const handleSave = () => {
    setShow(false);
    dispatch(setCalculatorPlatform(calculatorPlatforms));
  };

  const popover = (
    <Popover
      style={{ marginLeft: 0 }}
      id="popover-basic"
      className="all-popover"
    >
      <Popover.Title
        as="h3"
        className="popover-title d-flex justify-content-between"
      >
        <span>Filter settings</span>
        <CloseIconWithTooltip
          onClick={() => {
            setShowPopover(false);
          }}
        />
      </Popover.Title>
      <Popover.Content className="popover-content">
        Select the platforms to compare pricing for.
      </Popover.Content>
      <Button onClick={() => {
        setShowPopover(false);
      }}
       className="popover-button">
        Okay
      </Button>
    </Popover>
  );

  return (
    <div>
      <OverlayTrigger
        show={showPopover}
        placement="right"
        overlay={popover}
        rootClose={true}
        rootCloseEvent="mousedown"
        trigger="click"
      >
        <Tooltip title="Calculator Settings" placement="top">
          <IconButton
            className="ml-2"
            onClick={() => {
              setShow(true);
              setShowPopover(false);
            }}
          >
            <FaFilter className="filter-icon" />
          </IconButton>
        </Tooltip>
      </OverlayTrigger>

      {show && (
        <CustomModal
          open={show}
          handleClose={() => setShow(false)}
          closeIcon={true}
          width={420}
          fixedCloseIcon
          background={isDarkMode ? "#101010" : "#fff"}
        >
          <div className="setting-wrapper">
            <h5 className="modal-title mb-2 mt-2">
              Filter Marketplaces and Platforms
            </h5>

            <div className="mt-2">
              <FormControl component="fieldset" className="w-100">
                <FormGroup aria-label="position">
                  <h6 className="filter-sub-title">
                    <b>
                      Select all platforms you sell on or want to sell on. This
                      will help us compare and suggest customized pricing for
                      you.
                    </b>
                  </h6>
                  <div className="settings-list">
                    <div className="pt-1">
                      {InitialCalcPlatform.map((platform, i) => {
                        return (
                          <div key={i}>
                            <FormControlLabel
                              value="end"
                              control={
                                <Checkbox
                                  name={platform.value}
                                  onChange={handleChange}
                                  checked={activeCalcId.includes(
                                    platform.value
                                  )}
                                />
                              }
                              label={platform.label}
                              labelPlacement="end"
                            />
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </FormGroup>
              </FormControl>

              <div className="mt-3 d-flex w-100 align-items-center justify-content-end">
                <CustomButton secondary onClick={handleReset}>
                  Clear
                </CustomButton>
                <CustomButton className="ml-3" onClick={handleSave}>
                  Save
                </CustomButton>
              </div>
            </div>
          </div>
        </CustomModal>
      )}
    </div>
  );
};

export default CalculatorSetting;
